import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var Access;
(function (Access) {
    Access["Denied"] = "denied";
    Access["Error"] = "error";
    Access["Granted"] = "granted";
    /** @deprecated No longer needed */
    Access["Mismatch"] = "mismatch";
    Access["Pending"] = "pending";
})(Access || (Access = {}));
export var ComponentName;
(function (ComponentName) {
    ComponentName["Checkout"] = "checkout";
    ComponentName["Configurator"] = "configurator";
    ComponentName["Fincalc"] = "fincalc";
    ComponentName["Insurance"] = "insurance";
    ComponentName["Myaccount"] = "myaccount";
    ComponentName["Se"] = "se";
})(ComponentName || (ComponentName = {}));
export var DealTypes;
(function (DealTypes) {
    DealTypes["Enquiries"] = "enquiries";
    DealTypes["Orders"] = "orders";
    DealTypes["Reservations"] = "reservations";
    DealTypes["SavedCars"] = "savedCars";
})(DealTypes || (DealTypes = {}));
export var DepositType;
(function (DepositType) {
    DepositType["Absolute"] = "absolute";
    DepositType["Percentage"] = "percentage";
})(DepositType || (DepositType = {}));
export var DisabledDeal;
(function (DisabledDeal) {
    DisabledDeal["DealExpired"] = "dealExpired";
    DisabledDeal["DealInfoOutOfDate"] = "dealInfoOutOfDate";
    DisabledDeal["DealNotAvailable"] = "dealNotAvailable";
    DisabledDeal["FinanceApplicationExists"] = "financeApplicationExists";
    DisabledDeal["ModifiedByDealer"] = "modifiedByDealer";
})(DisabledDeal || (DisabledDeal = {}));
export var FacetOptionStatus;
(function (FacetOptionStatus) {
    FacetOptionStatus["Disabled"] = "DISABLED";
    FacetOptionStatus["Enabled"] = "ENABLED";
    FacetOptionStatus["Selected"] = "SELECTED";
})(FacetOptionStatus || (FacetOptionStatus = {}));
export var FeatureType;
(function (FeatureType) {
    FeatureType["Multi"] = "multi";
    FeatureType["Mutex0"] = "mutex0";
    FeatureType["Mutex1"] = "mutex1";
})(FeatureType || (FeatureType = {}));
export var FinanceApplicationJourney;
(function (FinanceApplicationJourney) {
    FinanceApplicationJourney["Default"] = "DEFAULT";
    FinanceApplicationJourney["OnlineApplication"] = "ONLINE_APPLICATION";
    FinanceApplicationJourney["RequestQuote"] = "REQUEST_QUOTE";
})(FinanceApplicationJourney || (FinanceApplicationJourney = {}));
export var FinanceFormCustomerType;
(function (FinanceFormCustomerType) {
    FinanceFormCustomerType["Business"] = "business";
    FinanceFormCustomerType["Private"] = "private";
})(FinanceFormCustomerType || (FinanceFormCustomerType = {}));
export var FinanceFormType;
(function (FinanceFormType) {
    FinanceFormType["Cash"] = "cash";
    FinanceFormType["Finance"] = "finance";
})(FinanceFormType || (FinanceFormType = {}));
export var FinanceResultType;
(function (FinanceResultType) {
    FinanceResultType["Cash"] = "cash";
    FinanceResultType["Error"] = "error";
    FinanceResultType["Finance"] = "finance";
    FinanceResultType["Na"] = "na";
    FinanceResultType["NotApplicable"] = "not_applicable";
})(FinanceResultType || (FinanceResultType = {}));
export var JourneyType;
(function (JourneyType) {
    JourneyType["ContinueInDealership"] = "continue_in_dealership";
    JourneyType["OnlineOrder"] = "online_order";
    JourneyType["PreOrderNow"] = "pre_order_now";
    JourneyType["ReserveOnline"] = "reserve_online";
    JourneyType["SaveMyBuild"] = "save_my_build";
})(JourneyType || (JourneyType = {}));
export var LoanTermPeriodUnit;
(function (LoanTermPeriodUnit) {
    LoanTermPeriodUnit["Month"] = "month";
})(LoanTermPeriodUnit || (LoanTermPeriodUnit = {}));
export var MiscellaneousOptionTypes;
(function (MiscellaneousOptionTypes) {
    MiscellaneousOptionTypes["ComplexInput"] = "complexInput";
    MiscellaneousOptionTypes["DefaultInput"] = "defaultInput";
    MiscellaneousOptionTypes["JlrPolandInput"] = "jlrPolandInput";
    MiscellaneousOptionTypes["MercedesPhInput"] = "mercedesPhInput";
    MiscellaneousOptionTypes["SimpleInput"] = "simpleInput";
    MiscellaneousOptionTypes["SubaruAuInput"] = "subaruAuInput";
})(MiscellaneousOptionTypes || (MiscellaneousOptionTypes = {}));
export var MyAccountRedirectTarget;
(function (MyAccountRedirectTarget) {
    MyAccountRedirectTarget["Login"] = "login";
    MyAccountRedirectTarget["SetPassword"] = "setPassword";
})(MyAccountRedirectTarget || (MyAccountRedirectTarget = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["FullPayment"] = "full_payment";
    PaymentType["OrderCar"] = "order_car";
    PaymentType["ReservationFee"] = "reservation_fee";
})(PaymentType || (PaymentType = {}));
export var PriceTypes;
(function (PriceTypes) {
    PriceTypes["FinalPrice"] = "FinalPrice";
    PriceTypes["NetPrice"] = "NetPrice";
})(PriceTypes || (PriceTypes = {}));
export var QuoteError;
(function (QuoteError) {
    QuoteError["CarLoading"] = "carLoading";
    QuoteError["ConfigLoading"] = "configLoading";
    QuoteError["FinanceCalculation"] = "financeCalculation";
    QuoteError["FinanceNotSupported"] = "financeNotSupported";
    QuoteError["FinanceProductNotApplicable"] = "financeProductNotApplicable";
    QuoteError["InvalidFinanceCriteria"] = "invalidFinanceCriteria";
})(QuoteError || (QuoteError = {}));
export var Source;
(function (Source) {
    Source["Checkout"] = "checkout";
    Source["FinanceApplication"] = "financeApplication";
    Source["Insurance"] = "insurance";
})(Source || (Source = {}));
export var StockListingView;
(function (StockListingView) {
    StockListingView["Aggregated"] = "aggregated";
    StockListingView["Individual"] = "individual";
})(StockListingView || (StockListingView = {}));
export var StockType;
(function (StockType) {
    StockType["Dealer"] = "dealer";
    StockType["Distribution"] = "distribution";
})(StockType || (StockType = {}));
export var TermUnit;
(function (TermUnit) {
    TermUnit["Month"] = "month";
})(TermUnit || (TermUnit = {}));
export var TokenType;
(function (TokenType) {
    TokenType["Bearer"] = "BEARER";
})(TokenType || (TokenType = {}));
export const LoginDocument = gql `
    mutation login($email: String!, $password: String!, $dealId: String) {
  login(email: $email, password: $password, dealId: $dealId) {
    accessToken
    expiresIn
    tokenType
  }
}
    `;
/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useLoginMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(LoginDocument, options);
}
//# sourceMappingURL=graphql.autogenerated.js.map